import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TARIFAS } from '../../../../core/enums/tarifas.enum';
import { APP_ROUTES } from '../../../../core/constants/routes.const';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { OfertasService } from '../../services/OfertasService';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { OfertaDtoIn } from '../../models/OfertaDtoIn.model';

@Component({
  selector: 'app-ofertas-crear',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    InputTextModule,
    DropdownModule,
    InputNumberModule,
    ButtonModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './ofertas-crear.component.html',
  styleUrl: './ofertas-crear.component.scss',
})
export class OfertasCrearComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly ofertasApi = inject(OfertasService);
  private readonly router = inject(Router);
  private readonly messages = inject(MessageService);

  ngOnInit() {
    this.form.valueChanges.subscribe(() => {
      const p1 = this.form.get('precioConsumidoP1')?.value ?? 0;
      const p2 = this.form.get('precioConsumidoP2')?.value ?? 0;
      const p3 = this.form.get('precioConsumidoP3')?.value ?? 0;

      const total = p1 + p2 + p3;

      this.form.get('precioTotalConsumido')?.setValue(total, { emitEvent: false });
    });
  }

  readonly R = APP_ROUTES;
  readonly tarifas = [
    { label: TARIFAS.TD20, value: TARIFAS.TD20 },
    { label: TARIFAS.TD30, value: TARIFAS.TD30 },
  ];

  form: FormGroup = this.fb.group({
    nombreCliente: ['', Validators.required],
    cups: ['', [Validators.required]],
    companiaActual: ['', Validators.required],
    tipoTarifa: [TARIFAS.TD20, Validators.required],
    diasFactura: [30, [Validators.required, Validators.min(1), Validators.max(90)]],
    potenciaP1: [0],
    potenciaP2: [0],
    consumoP1: [0],
    consumoP2: [0],
    consumoP3: [0],
    precioConsumidoP1: [0],
    precioConsumidoP2: [0],
    precioConsumidoP3: [0],
    precioTotalConsumido: [{ value: 0, disabled: true }],
    precioTotalPotencia: [0],
    otrosCostes: [0],
    bonoSocial: [0],
    regularizacionFinanciacionBs: [0],
    rdTopeGas: [0],
    descuento: [0],
    impuestoElectricidad: [0],
    alquilerDeEquipos: [0],
    iva: [21],
  });

  loading = false;

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const dto: OfertaDtoIn = this.form.getRawValue() as OfertaDtoIn;

    this.loading = true;
    this.ofertasApi.createOferta(dto).subscribe({
      next: (oferta) => {
        this.messages.add({
          severity: 'success',
          summary: 'Oferta creada',
          detail: `Se creó la oferta #${oferta.id}`,
        });
        this.router.navigate([`/${this.R.OFERTAS.DETALLE(oferta.id)}`]).then();
      },
      error: () => {
        this.messages.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo crear la oferta',
        });
      },
      complete: () => (this.loading = false),
    });
  }
}
